import { LicenseUsageDetailsResponse } from '../../company/common/licensingGrid/types/licensing-grid-responses';
import { CompanyActionContext } from '../../company/common/types/CompanyActionContext';
import { CompanyLicenseInformation } from '../types/CompanyLicenseInformation';
import { MonthlyProductType } from '../types/MonthlyProductType';
import _ from 'lodash';
import { LicenseConstants } from '../LicenseConstants';
import { getRoundedTimestampToMidnight } from "@nirvana/shared/time";

export function checkExistingIncompatibleProducts(
  incompatibleProductIds: number[] | undefined,
  licenseUsageDetails: LicenseUsageDetailsResponse | undefined,
  checkOnlyBaseProducts: boolean
) {
  if (!(incompatibleProductIds && licenseUsageDetails?.data)) {
    return false;
  }

  for (const licenseUsageData of licenseUsageDetails.data) {
    if (!licenseUsageData.productId) {
      continue;
    }

    if (
      checkOnlyBaseProducts &&
      !licenseUsageData.isAddon &&
      incompatibleProductIds.includes(licenseUsageData.productId)
    ) {
      return true;
    }

    if (!checkOnlyBaseProducts && incompatibleProductIds.includes(licenseUsageData.productId)) {
      return true;
    }
  }

  return false;
}

export function checkLicenseMeetsDependencies(
  dependentProductIds: number[] | undefined,
  licenseUsageDetails: LicenseUsageDetailsResponse | undefined
) {
  if (!dependentProductIds || dependentProductIds.length === 0) {
    return true;
  }

  if (!licenseUsageDetails?.data && dependentProductIds.length > 0) {
    return false;
  }

  if (!licenseUsageDetails?.data) {
    return true;
  }

  const existentProductIds = licenseUsageDetails.data.map(l => l.productId).filter(Number);

  return dependentProductIds.filter(productId => existentProductIds.includes(productId)).length > 0;
}

export function getAvailableProductTypes(
  context: CompanyActionContext,
  licenseInfo: CompanyLicenseInformation
): MonthlyProductType[] {
  const parentDelegableProducts = CompanyLicenseInformation.getParentDelegableProducts(licenseInfo);

  if (context === CompanyActionContext.Create) {
    return parentDelegableProducts;
  }

  // add the edited company's assigned product type in the dropdown
  const editedCompanyAssignedProductType = CompanyLicenseInformation.getEditedCompanyAssignedProductType(licenseInfo);

  return _.union(parentDelegableProducts, [editedCompanyAssignedProductType]);
}

export function isLv2License(licenseKey: string): boolean {
  return licenseKey.length === LicenseConstants.LicenseKeyLengthLV2;
}

export function getSubscriptionFormEndDateMinValue(timezone: string): number {
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 1);
  const tomorrowTimestamp = currentDate.getTime();
  return getRoundedTimestampToMidnight(tomorrowTimestamp, timezone) / 1000;
}
